import sjcl from "sjcl";
import { httpGet, httpPut, httpPost } from "./AbstractService";
import ENDPOINTS from "../data/endpoints.json";

export const SCORE_QR_KEY = "Gpjmnnz5i1Yo6zhMqu5hwuZgb3maFiOa";

export const getStudentScores = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].user}/user/score`);
};

export const getDayConsequences = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].user}/user/consequence`);
};

export const getScoreCategories = (school, jwt) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].school}/school/score/category`,
  );
};

export const getScoreConsequences = (school, jwt) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].school}/school/score/consequence`,
  );
};

export const getScorePeriods = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].school}/school/score/period`);
};

export const saveADPoints = (
  school,
  jwt,
  activityDateEid,
  studentEids,
  selectedScoreCategory,
  selectedScoreValue,
) => {
  return httpPut(
    jwt,
    ENDPOINTS[school.region].ad + `/activity-date/${activityDateEid}/score`,
    { studentEids, selectedScoreCategory, selectedScoreValue },
  );
};

export const calculateConsequences = (
  school,
  jwt,
  studentEids,
  categoryId,
  period,
) => {
  return httpPost(
    jwt,
    ENDPOINTS[school.region].score + `/score/consequence/calculate`,
    { studentEids, categoryId, period },
  );
};

export const getPreviousScores = (
  school,
  jwt,
  studentEids,
  dateStart = null,
  dateEnd = null,
) => {
  return httpPost(jwt, ENDPOINTS[school.region].score + `/score/previous`, {
    studentEids,
    dateStart,
    dateEnd,
  });
};

export const saveScores = (school, jwt, date, scores) => {
  return httpPost(jwt, ENDPOINTS[school.region].score + `/score/indiv`, {
    date,
    scores,
  });
};

export const getScorePasses = (school, jwt, scoreEids) => {
  return httpPost(jwt, ENDPOINTS[school.region].score + `/score/pass`, {
    scoreEids,
  });
};

export const deleteScores = (school, jwt, scoreEids) => {
  return httpPut(jwt, ENDPOINTS[school.region].score + `/score/delete`, {
    scoreEids,
  });
};

export const updateScoreValue = (school, jwt, scoreEid, value) => {
  return httpPut(
    jwt,
    ENDPOINTS[school.region].score + `/score/${scoreEid}/update`,
    { value },
  );
};

export const updateScoreComment = (school, jwt, scoreEid, value) => {
  return httpPut(
    jwt,
    ENDPOINTS[school.region].score + `/score/${scoreEid}/update-comment`,
    { value },
  );
};

export const searchScores = (
  school,
  jwt,
  dateStart,
  dateEnd,
  period,
  scoreCategoryIds,
  groupCode,
  studentEids,
  studentListEid,
  includeDeleted,
  includeArchived,
  tagEids,
) => {
  return httpPost(jwt, `${ENDPOINTS[school.region].score}/score/search`, {
    dateStart,
    dateEnd,
    period,
    scoreCategoryIds,
    groupCode,
    studentEids,
    studentListEid,
    includeDeleted,
    includeArchived,
    tagEids,
  });
};

export const getTardyScoreCategory = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].score}/score/tardy`);
};

export const encryptTardy = (key, teacherEid, categoryId) => {
  const value = `${teacherEid}/${categoryId}`;
  console.log(value);
  return btoa(sjcl.encrypt(key, value));
};

export const decryptTardy = (key, value) => {
  const decrypted = sjcl.decrypt(key, atob(value));
  const splitted = decrypted.split("/");
  return {
    teacherEid: splitted[0],
    categoryId: splitted[1],
  };
};

export const doTardyQrScore = (
  school,
  jwt,
  teacherEid,
  categoryId,
  studentEid = null,
  comment = null,
) => {
  return httpPost(jwt, `${ENDPOINTS[school.region].score}/score/tardy`, {
    teacherEid,
    categoryId,
    studentEid,
    comment,
  });
};

export const createKioskTardy = (
  school,
  jwt,
  sourceId,
  sourceStatus,
  scoreCategoryLocationEid = null,
) => {
  return httpPost(jwt, `${ENDPOINTS[school.region].score}/score/tardy/kiosk`, {
    sourceId,
    sourceStatus,
    scoreCategoryLocationEid,
  });
};

export const getKioskPrintables = (school, jwt, sourceId) => {
  return httpPost(
    jwt,
    `${ENDPOINTS[school.region].score}/score/tardy/kiosk/print`,
    { action: "PRINT", sourceId },
  );
};

export const updatePrintable = (school, jwt, printableEid) => {
  return httpPost(
    jwt,
    `${ENDPOINTS[school.region].score}/score/tardy/kiosk/print`,
    { action: "UPDATE", printableEid },
  );
};

export const getStudentTags = (school, jwt, eid) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].score}/student/${eid}/tags`);
};

export const adminUpdateStudentTags = (school, jwt, eid, eids) => {
  return httpPut(jwt, `${ENDPOINTS[school.region].score}/student/${eid}/tags`, {
    eids,
  });
};

export const adminArchiveScores = (school, jwt, dateStart, dateEnd) => {
  return httpPut(jwt, `${ENDPOINTS[school.region].score}/score/archive-range`, {
    dateStart,
    dateEnd,
  });
};

export const getScoreCategoryConsequences = (school, jwt, id) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].score}/score/category/${id}/consequence`,
  );
};

export const adminUpdateScoreTime = (school, jwt, eid, newDateTime) => {
  return httpPut(jwt, ENDPOINTS[school.region].score + `/score/time`, {
    eid,
    newDateTime,
  });
};

export const adminAddCheckinComment = (
  school,
  jwt,
  commentStartDate,
  commentEndDate,
  studentEids,
  commentId,
  commentText,
) => {
  return httpPost(jwt, ENDPOINTS[school.region].score + `/student/comment`, {
    commentText,
    studentEids,
    commentStartDate,
    commentEndDate,
    commentId,
  });
};

export const adminGetScoreCategories = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].score}/score/category`);
};

export const getScoreCategoryLocation = (school, jwt, eid) => {
  return httpGet(
    jwt,
    ENDPOINTS[school.region].score + `/score/category-location/${eid}`,
  );
};

export const addScoreCategoryLocation = (
  school,
  jwt,
  scoreCategoryId,
  locationEid,
) => {
  return httpPost(
    jwt,
    ENDPOINTS[school.region].score +
      `/score/category/${scoreCategoryId}/location`,
    {
      locationEid,
    },
  );
};

export const removeScoreCategoryLocation = (
  school,
  jwt,
  scoreCategoryId,
  locationEid,
) => {
  return httpPut(
    jwt,
    ENDPOINTS[school.region].score +
      `/score/category/${scoreCategoryId}/location`,
    {
      locationEid,
    },
  );
};

export const saveFulfillment = (school, jwt, scoreEid, comment) => {
  return httpPost(jwt, ENDPOINTS[school.region].score + `/score/fulfillment`, {
    scoreEid,
    comment,
  });
};

export const saveFulfillments = (school, jwt, scoreEids, comment) => {
  return httpPost(jwt, ENDPOINTS[school.region].score + `/score/fulfillment`, {
    scoreEids,
    comment,
  });
};

export const getStudentNotFullfillments = (school, jwt, eid) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].score}/student/${eid}/unfulfilled`,
  );
};

export const getScoreResetDates = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].score}/score/reset-date`);
};

export const updateScoreResetDate = (school, jwt, id, date) => {
  return httpPut(jwt, `${ENDPOINTS[school.region].score}/score/reset-date`, {
    id,
    date,
  });
};

export const getMyStudentScores = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].score}/score/my-students`);
};

export const initCheckinHours = (school, jwt, monday) => {
  return httpPost(jwt, ENDPOINTS[school.region].score + `/checkin/init-hours`, {
    monday,
  });
};

export const buildScores = (
  categoryId,
  consequenceEid,
  scoreCategoryTardiness,
  studentEids,
  consequenceMap,
  comment,
  commentId,
  period,
  scoreValue,
  reasonId
) => {
  const scores = [];

  // apply same category and value to individuals
  for (let i = 0; i < studentEids.length; i++) {
    const studentEid = studentEids[i];
    let conEid = "";
    let fieldValue = 0;

    // if calculated
    if (consequenceMap[studentEid] != null) {
      conEid = consequenceMap[studentEid].consequenceEid;
      fieldValue = consequenceMap[studentEid].value;
      if (conEid == null) {
        conEid = "";
      }
      if (fieldValue == null) fieldValue = 0;
    } else {
      // if manual
      conEid = consequenceEid;
    }

    let activityId = null;
    let activityPeriod = 0;
    let countValue = 1;
    if (scoreCategoryTardiness === "Y") {
      if (consequenceMap[studentEid] != null) {
        activityId = consequenceMap[studentEid].activityId;
        activityPeriod = consequenceMap[studentEid].activityPeriod;
        countValue = consequenceMap[studentEid].value;
      }
    }

    scores.push({
      eid: studentEid,
      categoryId: categoryId,
      score: scoreValue,
      ordinal: 1,
      countValue: countValue,
      type: "individual",
      comment: comment,
      conEid: conEid,
      period: period,
      commentId: commentId,
      fieldValue: fieldValue,
      activityId: activityId,
      activityPeriod: activityPeriod,
      reasonId: reasonId,
    });
  }

  return scores;
};

export const getScoreReasons = (school, jwt, scoreCategoryId) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].score}/score/category/${scoreCategoryId}/reason`);
};